<td data-test-id="notification-body" (click)="markNotificationRead()">
    <div data-test-id="notification-error" class="text-red" style="display: flex; justify-content: center; align-items: center" *ngIf="errorMessage">{{ errorMessage }}</div>
    <div data-test-id="notification-title" class="notification-title"
         [ngClass]="{'unread': !notification.read }">
        <div class="bullet" [ngClass]="bulletColor"></div>
        <span [innerHTML]="notification.label"></span>
    </div>
    @if (canRetry) {
        <button data-test-id="notification-retry-btn" type="button" class="btn btn-xs btn-secondary"
                [disabled]="retrying" (click)="retryReportGeneration($event)">
            {{ retrying ? 'Retrying…' : 'Retry' }}
        </button>
    }
    <div class="notification-descr" *ngIf="notification.message">
        <ng-container>
            {{ (expandable && expanded) || !expandable ? notification.message : notification.message.slice(0, 30) + '...' }}
        </ng-container>&nbsp;
        <span data-test-id="notification-readmore" class="readmore" *ngIf="expandable" (click)="toggleExpanded()">{{ expanded ? 'Less': 'More' }}</span></div>
    <div data-test-id="notification-date" class="notification-date">{{ notification.create_date | date :'MMM d, y \'at\' h:mm a'}}</div>
</td>
<td>
    <div data-test-id="notification-delete-btn" class="btn btn-xs btn-circle btn-transparent btn-close" (click)="deleteNotification()">
        <svg ycnIcon name="icon-close-circle"></svg>
    </div>
</td>
